const en = {
  'checkAddressTips':'Your enterprise sets the range of delivery address. The default address is within the range of delivery address',
  'lookCity': 'View designated city',
  'checkAddressTipsForm': 'Prompt: your enterprise sets the range of delivery address. You only select the city designated by enterprise',
  '您当前仅支持以下收货区域':'Only available for following delivery area',
  '说明': 'Instructions',
  '失效': 'Invalid',
  '规格': 'Specification',
  '配件': 'Accessories',
  '暂不可用': 'Not available',
  '暂无不可用积分': 'No unavailable points temporarily',
  '次': 'Times',
  '配送方式': 'Mode of Distribution: ',
  '期望发货时间': 'Expected time of delivery: ',
  '商品总价': 'Total price of products',
  'orderTotal': 'XXX pcs, sub total &&&',
  '立减': 'Deducted',
  '专享优惠': 'Exclusive Offer',
  '优惠券': 'Coupon',
  '合计': 'Total',
  'payTips': ' are here now! Please Select',
  '福利卡': 'Benefit card',
  '余额': 'balances',
  '积分': 'Points',
  'points': 'points',
  '张可用': 'Pcs available',
  '无可用优惠券': 'No coupon available',
  'GiftOrMetering': 'Gift Card/ Metering Card',
  '次卡': 'Metering Card',
  '点卡': 'Gift Card',
  '还需支付': 'Need to pay',
  '提交订单': 'Submit Order',
  '取消': 'Cancel',
  '暂不取消': 'Undecided',
  '确认取消': 'Cancel',
  '账户余额': 'Account Balances',
  '账户积分': 'Account Points',
  '可用卡': 'Available Cards',
  '不可用卡': 'Unavailable Cards',
  '绑定新卡': 'Bind another card',
  '可用余额': 'Available Balances',
  '可用': 'Available',
  '去使用': 'To use',
  '卡号': 'Card No.',
  '有效期至': 'Expiry Date:',
  '使用范围': 'Range of Use',
  '确定': 'Confirm',
  '暂无不可用福利卡': 'No unavailable benefit card temporarily',
  '暂无可用福利卡': 'No benefit card available temporarily',
  '收货地址': 'Shipping Address',
  '新建收货地址': 'Add new shipping address',
  '暂无': 'No ',
  '请选择送达时间': 'Pls select delivery time',
  '请选择期望送达时间': 'Pls select Expected time',
  '期望送达时间': 'Expected time of arrival: ',
  '配送时间': 'Delivery time: ',
  '请选择发货时间': 'Pls select delivery time',
  '请修改发货时间': 'Please modify the delivery time',
  'payTime': 'Delivery time will be postponed to next day if payment is later than deadline. Alteration is suggested.',
  '配件选择': 'Accessories selection',
  '请选择配件': 'Pls select accessories',
  '支付结果': 'Result',
  '支付成功': 'Successful',
  '实付': 'Paid',
  '去逛逛': 'Go now',
  '查看订单': 'View order',
  '支付失败': 'Payment failure',
  '运费': 'Freight',
  'payerror': 'Payment goes wrong. All rights and interests paid (bonus card, account balance and credits) will be refunded later',
  'discountTips': 'Deduction includes the ammout of cash back, special offer and flash sale',
  'orderError1': 'Sorry, part of products invalid in the order, ',
  'orderError2': ' recalculating your order acount',
  'openPayChannel': 'Open XXX password-free deduction',
  '确认抵扣': 'Confirm deduction',
  'orderGoodsInvalid': 'Sorry,your order is invalid',
  '我知道了': 'I got it',
  '返回购物车': 'Return to shopping cart',
  '返回详情页': 'Back detail',
  'createAddressTips': 'Please establish new order before submitting',
  '去新建': 'Establish now',
  'changeAddress': 'You choose new address when browsing products. Are you sure to complete it?',
  '去完善': 'Complete now',
  '不可用': 'Unavailable',
  'notCoupon': 'No available coupons for current settlement~',
  'GoodsNotCoupon': 'Available coupons for current settlement~',
  'mutualExclusion': 'Following discount and coupon are exclusive',
  '知道了': 'Read',
  '微创年度健康福利提示': 'Weichuang annual healthy welfare prompt',
  'wcTips1': 'The annual healthy welfare service for employees contains physical examination, dentistry and epidemic prevention package, which is only one optional and non-refundable after confirmation',
  '确认': 'Confirm',
  'service': 'Account exception, any question, please contact customer service or dial 400-003-1010',
  '免密抵扣使用规则': 'Using rules of password-free deduction',
  'mianmiTips': 'Password-free deduction is valid if amount is ≤ XXX. Excessive amount needs payment password',
  '填写并核对收货信息': 'Fill out and check the receiving information.',
  '应付金额': 'Amount Due: ',
  '收货信息': 'Delivery Info',
  '信息确认': 'Information confirmation',
  '生日牌内容': 'Birthday plate content',
  '返回修改': 'Return for modification',
  '新增收货地址': 'Add New Address',
  '编辑收货地址': 'Edit Address',
  '最多只能创建25条收货地址': 'Only maximum 25 delivery addresses',
  'goodsInvError': 'Sorry, your order contains some invalid products and the amount has been recalculated',
  'goodsXiaJia': 'Sorry, your order contains take-down products',
  'addressError': 'Sorry, your order contains products that cannot be delivered to designated address.',
  '请选择用户的配送地址': 'Pls select user’s delivery address',
  '使用优惠券': 'Use coupon',
  '基础运费': 'Basic freight',
  '续重运费': 'Additional weight',
  '运费收取规则': 'Freight collection rule',
  '福利卡抵扣': 'Deducted by benefit card',
  '账户余额抵扣': 'Deducted by account balances',
  '账户积分抵扣': 'Deducted by account points',
  '是否去使用': 'Do you use',
  'NoPwd1': 'No payment password set',
  'NoPwd2': 'please select settings',
  '立即设置': 'Set now',
  '是否退出设置支付密码': 'Exit setting password or not',
  '继续设置': 'Continue to set',
  '退出': 'Exit',
  '密码设置成功': 'Set password success',
  '将为您生成订单并提交': ' the order will be generated and submitted',
  '本次抵扣失败': 'Deduction failed',
  '请重新选择并提交订单': 'please re-select and submit the order',
  '重新选择': 'Re-select',
  '输入支付密码': 'Please enter payment password',
  '密码已被冻结': 'Password has been frozen, try again in ',
  '后再试': ' ',
  '忘记密码': 'Forgot Password',
  'FreightTips': 'DONGFANGFULI.COM supermarket will exempt order from freight if amount paid is more than XXX. QQQ is required for basic freight if amount paid is less than &&&.',
  '绑定您的手机号': 'Bind your Phone Number',
  '最多14个汉字或者28个字母': 'Maximum 14 Chinese characters or 28 letters',
  'couponTips': 'Sorry, coupons can only be used on mobile devices',
  'scanCode': 'Scan QR code to place an order, it is more favorable to place an order with coupons',
  'scanCodeTips1': '<span style="width: 34%">Open "scan" via the following methods</span><span style="width: 28%">Scan QR code below</span><span style="width: 37%">Access to order submition page to choose available coupons</span>',
  'scanCodeTips2': 'Use company\' s office software scan (such as work WeChat, Dingtalk)',
  'scanCodeTips3': 'Use WeChat scan',
  'scanCodeTips4': 'Use Dbenefit scan',
  'scanCodeTips5': 'My coupon is not available for PC. Pls enter applet for view',
  'scanCodeTips6': 'Wechat scanning to enter DONGFANGFULI.COM applet',
  'scanCodeTips7': 'Open “Wechat - Discover - Scan”',
  'scanCodeTips8': 'Scan applet code below',
  'scanCodeTips9': 'Enter applet: use coupon to place an order after shopping',
  'KDSJ': 'Weekday/Weekend/Holiday Available',
  '工作日／周末／假日均可': 'Weekday/Weekend/Holiday Available',
  '工作日／周末／假日均可 ': 'Weekday/Weekend/Holiday Available',
  '请选择时间': 'Pls select time',
  'distributionTime': 'The delivery time of the goods is subject to the actual delivery time, which is expected to take 1-5 days',
  'DeliveryTimeTip': 'Delivery is estimated to be prior to  XXXX. Specific delivery time is subject to real-time logistics.',
  '精准配送': 'Precise delivery',
  '普通配送': 'Ordinary delivery',
  '指定日期发货': 'Specified Date of Delivery',
  '共': 'Pcs',
  '件商品': 'products',
  '小计': 'subtotal',
  '含运费': 'Feight XXX included',
  '免运费': 'freight free',
  '已免运费': 'freight free',
  'couponCount': 'XXX Pcs coupons in total,QQQ Pcs are available for the order',
  'couponCount2': 'scan the QR code to get your special offer',
  '福豆': 'FuDou',
  '商品信息': 'Product Information',
  '确认商家信息和配送方式': 'Confirm Business Info.and Delivery Method',
  '订单已全额抵扣': 'The order has been fully deducted',
  '次卡和点卡支付无法同时使用': 'Metering card and gift card payment cannot be used at a time',
  '失效商品': 'Invalid Product',
  'DeliveryTimeTips': 'Delivery is estimated to be prior to XXXX. Specific delivery time is subject to real-time logistics.',
  'DeliveryTimeTips2': 'Delivery time is subject to real-time logistics. 1-5 days are needed.',
  'DeliveryTimeTips3': 'It is expected to be delivered in 1-5 days (unless for remote areas), and the specific delivery time is subject to the actual logistics delivery time',
  '优惠劵': 'Coupon',
  '订单确认': 'Comfirm Order',
  'CardStatus': 'Unused benefit XXX avaialble, use or not?',
  '单价': 'Unit Price',
  '数量': 'Quantity',
  '金额': 'Amount',
  'CardTips': 'Use XXX for deduction',
  '请添加收货信息': 'Please add shipping information',
  '该商品已下架': 'Take-down',
  '该商品在收货地址内不可售': 'This product is not for sale within this delivery add.',
  '该商品在收货地址内库存不足': 'This product has insufficient inventory within this delivery add.',
  'tagsLengthTips': 'Pls input custom tag name, less than five characters',
  // eslint-disable-next-line
  'haiwaiTis': "*Tips: When purchasing overseas products, you need to declare customs clearance and verify your real name. Please fill in the consignee's ID card and real name.",
  '请输入真实姓名': 'Please enter your real name',
  '请输入正确的身份证号码': 'Please enter the correct ID number',
  '身份证号': 'ID Card No. ',
  '姓名': 'Name',
  '已为您输入最大可用次数': 'You have entered the maximum number of available times',
  'errorAddressTips': 'There is an error in the operation. There is no valid address information',
  // eslint-disable-next-line
  'errorAddressTips2': "There is an error in the operation. Before entering this page, there must be valid address information stored in the cookie, otherwise you can't get the information of the ordered product. Thank you for your cooperation",
  'errorAddressTips3': 'There is an error in the operation. To enter this page, you need to include the information of the ordered product in the url',
  '抵扣金额已为您重新计算': 'Recalculating deducted amount',
  '一个商品只能使用一次次卡': 'A metering card can only be used once for a product',
  '订单已取消': 'Order has been canceled',
  '订单已删除': 'Order has been deleted',
  '您要取消订单吗': 'Are you sure you want to cancel this order?',
  '您要申请退款吗': 'Do you want to apply for a refund?',
  '您使用的次卡继续退款申请吗':'You used the times card to purchase the combined products, this refund application will cancel the waybills related to the combined products, do you want to continue your refund application?',
  '用户端取消':'用户端取消',
  '请输入订单编号进行查询': 'Pls input order no. for query',
  '请输入正确的身份证号': 'Please enter the correct ID number',
  // eslint-disable-next-line
  '温馨提示购买海外商品': "*Tips: When purchasing overseas products, you need to declare customs clearance and verify your real name. Please fill in the consignee's ID card and real name.",
  'totalProduct1': ' ',
  'totalProduct2': ' Pcs products',
  '使用抵扣1': 'Use ',
  '使用抵扣2': ' for deduction',
  '倒计时天': 'day',
  '倒计时年': '-',
  '倒计时月': '-',
  '倒计时日': ' ',
  // eslint-disable-next-line
  '组合商品不支持查看详情':"I am a combination of products, and I don't support viewing details for the time being",
  '抱歉地址最多只能有25条': 'Sorry, you can only have 25 addresses at most. Delete one and then create it.',
  'presaleOrder':
    'Product will be delivered within sss to eee if you place an order now',
  '该商家已开通自定义运费服务': 'This merchant has the custom freight service to offer. Freight is related to delivery method and address, and subject to the order confirmation page.',
  '收货地址修改，运费发生变化': 'Freight is subject to delivery address.',
  '配送服务': "Distribution Service",
  '发货': ' of delivery',
  '送达': ' of delivery',
  '配送': ' of delivery',
  '账号': 'CardNo',
  '过期': ' exp.',
};
const cn = {
  'checkAddressTips':'您的企业设置了收货地址范围，默认地址不在指定城市范围内',
  'lookCity': '查看指定城市',
  '您当前仅支持以下收货区域':'您当前仅支持以下收货区域',
  'checkAddressTipsForm': '提示：您的企业设置了收货地址范围，仅可选择企业指定的城市',
  '抵扣金额已为您重新计算': '抵扣金额已为您重新计算',
  '一个商品只能使用一次次卡': '一个商品只能使用一次次卡',
  'errorAddressTips': '操作有误，无有效的地址信息',
  'errorAddressTips2': '操作有误，进入该页面前必须有有效的地址信息存入 cookie，否则无法获取下单商品信息。谢谢合作',
  'errorAddressTips3': '操作有误，进入该页面需要在 url 中带下单商品信息',
  '已为您输入最大可用次数': '已为您输入最大可用次数',
  '请修改发货时间': '请修改发货时间',
  'haiwaiTis': '*温馨提示：购买海外商品时，需进行海关清关申报及实名验证,请填写收货人身份证和真实姓名。',
  '姓名': '姓名',
  '请输入真实姓名': '请输入真实姓名',
  '请输入正确的身份证号码': '请输入正确的身份证号码',
  '身份证号': '身份证号',
  'tagsLengthTips': '请输入自定义标签名称，最多5个字',
  '该商品已下架': '该商品已下架',
  '该商品在收货地址内不可售': '该商品在收货地址内不可售',
  '该商品在收货地址内库存不足': '该商品在收货地址内库存不足',
  '失效': '失效',
  '规格': '规格',
  '配件': '配件',
  '次': '次',
  '暂不可用': '暂不可用',
  '暂无不可用积分': '暂无不可用积分',
  '配送方式': '配送方式:',
  '期望发货时间': '期望发货时间: ',
  '商品总价': '商品总价',
  '运费': '运费',
  'orderTotal': '共 XXX 件，小计 &&&',
  '立减': '立减',
  '专享优惠': '专享优惠',
  '优惠券': '优惠券',
  '合计': '合计',
  'payTips': ' 移到这里啦，请选择！',
  '福利卡': '福利卡',
  '余额': '余额',
  '积分': '积分',
  '张可用': '张可用',
  '无可用优惠券': '无可用优惠券',
  'GiftOrMetering': '点卡/次卡',
  '次卡': '次卡',
  '点卡': '点卡',
  '还需支付': '还需支付',
  '提交订单': '提交订单',
  '取消': '取消',
  '暂不取消': '暂不取消',
  '确认取消': '确认取消',
  '账户余额': '账户余额',
  '账户积分': '账户积分',
  '可用卡': '可用卡',
  '不可用卡': '不可用卡',
  '绑定新卡': '绑定新卡',
  '可用余额': '可用余额',
  '可用': '可用',
  '去使用': '去使用',
  '卡号': '卡号:',
  '有效期至': '有效期至:',
  '使用范围': '使用范围',
  '确定': '确定',
  '暂无不可用福利卡': '暂无不可用福利卡',
  '暂无可用福利卡': '暂无可用福利卡',
  '收货地址': '收货地址',
  '新建收货地址': '新建收货地址',
  '暂无': '暂无',
  '请选择送达时间': '请选择送达时间',
  '请选择期望送达时间': '请选择期望送达时间',
  '期望送达时间': '期望送达时间:',
  '配送时间': '配送时间:',
  '请选择发货时间': '请选择发货时间',
  'payTime': '支付如超过截单时间，会安排次日发货，建议修改',
  '配件选择': '配件选择',
  '请选择配件': '请选择配件',
  '支付结果': '支付结果',
  '支付成功': '支付成功',
  '实付': '实付',
  '去逛逛': '去逛逛',
  '查看订单': '查看订单',
  '支付失败': '支付失败',
  'payerror': '支付遇到问题，已支付的权益（福利卡、账户余额、账户积分）稍后原路退回',
  'discountTips': '立减包含商品满减、特价、抢购的优惠金额',
  'orderError1': '抱歉，您订单中部分商品已失效，',
  'orderError2': '订单金额等已为您重新计计算',
  'openPayChannel': '开通XXX免密抵扣',
  '确认抵扣': '确认抵扣',
  'orderGoodsInvalid': '抱歉，您的订单商品已失效',
  '我知道了': '我知道了',
  '返回购物车': '返回购物车',
  '返回详情页': '返回详情页',
  'createAddressTips': '提交订单前，请先新建',
  '去新建': '去新建',
  'changeAddress': '您在浏览商品过程中选择了',
  '去完善': '去完善',
  '不可用': '不可用',
  'notCoupon': '当前结算商品中暂无可用的优惠券哦～',
  'GoodsNotCoupon': '当前结算商品中暂无不可用的优惠券哦～',
  'mutualExclusion': '以下立减与优惠券互斥',
  '知道了': '知道了',
  '微创年度健康福利提示': '微创年度健康福利提示',
  'wcTips1': '员工年度健康福利服务仅体检、齿科、防疫包选其一，不能同时享有，确认支付后无法退款',
  '确认': '确认',
  'service': '账户异常，如有疑问请联系在线客服，或拨打400-003-1010',
  '免密抵扣使用规则': '免密抵扣使用规则',
  'mianmiTips': '免密仅限抵扣金额≤XXX 时生效，超过则还需要输入支付密码',
  '应付金额': '应付金额：',
  '收货信息': '收货信息',
  '信息确认': '信息确认',
  '生日牌内容': '生日牌内容',
  '返回修改': '返回修改',
  '新增收货地址': '新增收货地址',
  '编辑收货地址': '编辑收货地址',
  '最多只能创建25条收货地址': '最多只能创建25条收货地址',
  'goodsInvError': '抱歉，您订单中部分商品已失效,订单金额已为您重新计算',
  'goodsXiaJia': '抱歉，您订单中部分商品已下架',
  'addressError': '抱歉，您订单中部分商品在所选地址下无法购买',
  '请选择用户的配送地址': '请选择用户的配送地址',
  '使用优惠券': '使用优惠券',
  '基础运费': '基础运费',
  '续重运费': '续重运费',
  '运费收取规则': '运费收取规则',
  '福利卡抵扣': '福利卡抵扣',
  '账户余额抵扣': '账户余额抵扣',
  '账户积分抵扣': '账户积分抵扣',
  '是否去使用': '是否去使用',
  'NoPwd1': '您还未设置支付密码',
  'NoPwd2': '请先设置',
  '立即设置': '立即设置',
  '是否退出设置支付密码': '是否退出设置支付密码',
  '继续设置': '继续设置',
  '退出': '退出',
  '密码设置成功': '密码设置成功',
  '将为您生成订单并提交': '将为您生成订单并提交',
  '本次抵扣失败': '本次抵扣失败',
  '请重新选择并提交订单': '请重新选择并提交订单',
  '重新选择': '重新选择',
  '输入支付密码': '输入支付密码',
  '密码已被冻结': '密码已被冻结，',
  '后再试': '后再试',
  '忘记密码': '忘记密码',
  'FreightTips': '当使用各项优惠（特价、满减、优惠券）后，东福超市按照单笔订单结算实付金额满 XXX 即免运费，不满 &&& 需支付 QQQ 基础运费',
  '绑定您的手机号': '绑定您的手机号',
  '最多14个汉字或者28个字母': '最多14个汉字或者28个字母',
  'couponTips': '抱歉，优惠券仅支持手机端使用',
  'scanCode': '扫码下单，使用优惠券更优惠',
  'scanCodeTips1': '<span style="width: 34%">通过以下方式，打开“扫一扫”</span><span style="width: 28%">扫描下方二维码</span><span style="width: 37%">进入提交订单页,选择相应的优惠券并使用</span>',
  'scanCodeTips2': '使用公司的办公软件的扫一扫（如：企微、钉钉）',
  'scanCodeTips3': '使用微信的扫一扫',
  'scanCodeTips4': '使用百福得APP的扫一扫',
  'scanCodeTips5': '我的优惠券暂未支持PC端，请进入小程序查看',
  'scanCodeTips6': '微信扫一扫, 即可进入东方福利网小程序',
  'scanCodeTips7': '打开“微信APP-发现-扫一扫”',
  'scanCodeTips8': '扫描下方小程序码',
  'scanCodeTips9': '进入小程序：购物后下单使用优惠券',
  'KDSJ': '工作日／周末／假日均可',
  '工作日／周末／假日均可': '工作日／周末／假日均可',
  '工作日／周末／假日均可 ': '工作日／周末／假日均可',
  '请选择时间': '请选择时间',
  'distributionTime': '商品送达时间以实际物流配送时间为准, 预计1-5天',
  'DeliveryTimeTip': '预计XXXX及之前送达，具体送达时间以实际物流配送时间为准。',
  '精准配送': '精准配送',
  '普通配送': '普通配送',
  '指定日期发货': '指定日期发货',
  '共': '共',
  '件商品': '件商品',
  '小计': '小计',
  '含运费': '含运费XXX',
  '免运费': '免运费',
  '已免运费': '已免运费',
  'couponCount': '您共有 XXX 张优惠券, 有 QQQ 张优惠券可以在本笔订单使用',
  'couponCount2': '点我扫码，立享优惠',
  '商品信息': '商品信息',
  '福豆': '福豆',
  '确认商家信息和配送方式': '确认商家信息和配送方式',
  '订单已全额抵扣': '订单已全额抵扣',
  '次卡和点卡支付无法同时使用': '次卡和点卡支付无法同时使用',
  '失效商品': '失效商品',
  'DeliveryTimeTips': '预计XXXX及之前送达，具体送达时间以实际物流配送时间为准',
  'DeliveryTimeTips2': '商品送达时间以实际物流配送时间为准,预计1-5天。',
  'DeliveryTimeTips3': "预计1-5天送达(偏远地区除外)，具体送达时间以实际物流配送时间为准",
  '优惠劵': '优惠劵',
  '订单确认': '订单确认',
  'CardStatus': '您有可用XXX未使用，是否使用？',
  '单价': '单价',
  '数量': '数量',
  '金额': '金额',
  'CardTips': '使用XXX抵扣',
  '请添加收货信息': '请添加收货信息',
  '说明': '说明',
  '订单已取消': '订单已取消',
  '订单已删除': '订单已删除',
  '您要取消订单吗': '您要取消订单吗',
  '您要申请退款吗': '您要申请退款吗?',
  '您使用的次卡继续退款申请吗':'您使用的次卡来购买组合商品，本次申请退款会将组合商品相关运单都取消，您想继续退款申请吗',
  '用户端取消':'用户端取消',
  '请输入订单编号进行查询': '请输入订单编号进行查询',
  '请输入正确的身份证号': '请输入正确的身份证号',
  '温馨提示购买海外商品': '*温馨提示：购买海外商品时，需进行海关清关申报及实名验证,请填写收货人身份证和真实姓名。',
  'totalProduct1': '共',
  'totalProduct2': '件商品',
  '使用抵扣1': '使用',
  '使用抵扣2': '抵扣',
  '倒计时天': '天',
  '倒计时年': '年',
  '倒计时月': '月',
  '倒计时日': '日',
  '组合商品不支持查看详情':'我是组合商品，暂不支持查看详情哦',
  '抱歉地址最多只能有25条': '抱歉，地址最多只能有25条，删一条再创建吧',
  'presaleOrder': '现在下单，商品将在 sss 至 eee 内发货',
  '该商家已开通自定义运费服务': '该商家已开通自定义运费服务，运费与配送方式及配送地址有关，运费信息以订单确认页为准',
  '收货地址修改，运费发生变化': '收货地址修改，运费发生变化',
  '配送服务': "配送服务",
  '发货': '发货',
  '送达': "送达",
  '配送': "配送",
  '账号': '账号',
  '过期': '过期',
};


export const data = {
  orderConfirm: {
    en,
    cn,
  },
  address: {
    en: {
      '期望':'Expected ',
      '预计':'Expected ',
      '发货时间':'time of delivery',
      '送达时间':'time of arrival',
      '更多地址More': 'More address',
      '订单已全额抵扣': 'The order has been fully deducted',
      '删除Delete': 'Delete',
      // '待完善':'To be completed',
      '收货地址': 'Shipping Address',
      '修改地址成功': 'Successfully modified address',
      '新建收货地址': 'Add new shipping address',
      '修改地址': 'Modify address',
      '删除': 'Delete',
      '设为默认': 'Set as default',
      '默认地址': 'Default address',
      '确认': 'Confirm',
      '取消': 'Cancel',
      '收货人': 'Consignee',
      '手机号': 'Phone Number',
      '所在地区': 'Region',
      '详细地址': 'Detailed \r\n Address',
      '邮政编码': 'Post Code',
      '地址标签': 'Address Tag',
      '家': 'Home',
      '公司': 'Co.',
      '学校': 'Sch',
      '设置为默认收货地址': 'Set as default shipping address',
      'addressTips': 'Reminder: this address is recommended by default for each order',
      'notice': 'Warm Tip: The Postal Administration informs that since September 01, 2018, the name of the recipient as well as the name of the sender on the logistics information of all express deliveries must be filled in with the real name, and it is prohibited to fill in with surnames and other characters. Please fill in the recipient information in your real name, otherwise no delivery will be made. Thank you for your cooperation!',
      '温馨提示': 'Reminder',
      '保存地址': 'Save Address',
      '已经到底了': 'No more updates',
      '详细地址提示': 'Street, house number, community, building number and room number, etc.',
      '请选择': 'Please select',
      '选择': 'Select',
      '请输入11位手机号': 'Please enter 11-digit phone number',
      '验证码': 'Identifying code',
      '请输入验证码': 'Pls input identifying code',
      '获取验证码': 'Obtain identifying code',
      '重新发送': 'Send again',
      '输入短信验证码': 'Please enter SMS verification code',
      '待完善': 'To be completed',
      '下一步': 'next',
      '新的支付密码': 'New payment password',
      '确认新的支付密码': 'Confirm new payment password',
      '输入4位数字密码': 'Input 4-digit password',
      '再次输入4位数字密码': 'Input 4-digit password again',
      '确认设置': 'Confirm setup',
      '请输入手机号码': 'Pls input phone number ',
      'checkCode': 'Check code has been sent to your phone, pls check',
      'freightPay': 'The expense of pay product shall be independently given to deliveryman, which is not included in total price ',
      '更多地址': 'More address',
      '新建地址': 'Add New Address',
      '编辑地址': 'Edit address',
      '请填写收货人姓名': 'Please fill in the consignee name',
      '请填写收货人手机号码': 'Please fill in the consignee mobile number',
      '配送至': 'Delivery Address',
      '收货地址删除成功': 'Successful',
      '收货地址删除失败': 'Failed',
      '最多只能输入5个字': 'Only input five words',
      '确定': 'Confirm',
      '编辑': 'Edit',
      '确认删除该地址吗': 'Are you sure to delete this address?',
      '再想想': 'Think twice',
      '修改的信息还未保存': 'You haven’t saved the alteration.',
      '确认现在返回么': 'Are you sure to return now?',
      '您还没有收货地址哦': 'You don\'t have delivery address ',
      '快去新建吧': 'Establish now ！~',
      '修改': 'Modify',
      '您要删除该收货地址吗': 'Are you sure to delete this delivery address?',
      'newAddressError': 'Mr./Mrs. X is forbidden. Pls fill in real information. Read prompt for details.',
      '收货人不能为空': 'Consignee shall not be vacant',
      '所在地区不能为空': 'Location shall not be vacant',
      'mobileError': 'Phone number format is wrong, pls re-enter',
      '手机号码不能为空': 'Phone number shall not be vacant',
      '详细地址不能为空': 'Detailed address shall not be vacant',
      '默认': 'Default',
      '请选择地址': 'Please select address',
      '请输入邮政编码': 'pls input zip code',
      '请修改发货时间': 'Please modify the delivery time',
      '请选择用户的配送地址': 'Please select the shipping address of the user',
      '运费最终运费以填写订单页为准': 'Freight is related to delivery and address. Final freight is subject to order page',
      '重量超过要运费': 'For weight more than X kg, additional freight will be charged. Freight is subject to the order.',
    },
    cn: {
      '期望':'期望',
      '预计':'预计',
      '发货时间':'发货时间',
      '送达时间':'送达时间',
      '更多地址More': '更多地址More',
      '删除Delete': '删除',
      // '待完善':'待完善',
      '请输入邮政编码': '请输入邮政编码',
      '请选择地址': '请选择地址',
      '修改地址成功': '修改地址成功',
      '默认': '默认',
      '收货地址': '收货地址',
      '新建收货地址': '新建收货地址',
      '修改地址': '修改地址',
      '删除': '删除',
      '设为默认': '设为默认',
      '默认地址': '默认地址',
      '确认': '确认',
      '取消': '取 消',
      '收货人': '收货人',
      '手机号': '手机号',
      '所在地区': '所在地区',
      '详细地址': '详细地址',
      '邮政编码': '邮政编码',
      '地址标签': '地址标签',
      '家': '家',
      '公司': '公司',
      '学校': '学校',
      '设置为默认收货地址': '设置为默认收货地址',
      'addressTips': '提醒：每次下单会默认推荐使用该地址',
      '温馨提示': '温馨提示',
      'notice': '温馨提示：2018.09.01起，邮管局通知：所有快递物流信息上收件人以及寄件人信息禁止出现X先生/X小姐等字样，务必实名填写。请您实名填写收件信息，否则将不予发货，谢谢配合！',
      '保存地址': '保存地址',
      '已经到底了': '已经到底了',
      '详细地址提示': '街道、门牌号、小区、楼栋号、单元室等',
      '请选择': '请选择',
      '选择': '选择',
      '请输入11位手机号': '请输入11位手机号',
      '验证码': '验证码',
      '请输入验证码': '请输入验证码',
      '获取验证码': '获取验证码',
      '重新发送': '重新发送',
      '输入短信验证码': '输入短信验证码',
      '待完善': '待完善',
      '下一步': '下一步',
      '新的支付密码': '新的支付密码',
      '确认新的支付密码': '确认新的支付密码',
      '输入4位数字密码': '输入4位数字密码，数字不能相同或连续',
      '再次输入4位数字密码': '再次输入4位数字密码',
      '确认设置': '确认设置',
      '请输入手机号码': '请输入手机号码',
      'checkCode': '校验码已发送至您的手机，请查收',
      '输入的密码4位数字不能相同或连续': '输入的密码4位数字不能相同或连续',
      '请再次输入四位数字支付密码': '请再次输入四位数字支付密码',
      'freightPay': '付费产品的费用需单独支付给配送员，此处不计入总价',
      '更多地址': '更多地址',
      '新建地址': '新建地址',
      '编辑地址': '编辑地址',
      '请填写收货人姓名': '请填写收货人姓名',
      '请填写收货人手机号码': '请填写收货人手机号码',
      '配送至': '配送至',
      '收货地址删除成功': '收货地址删除成功',
      '收货地址删除失败': '收货地址删除失败',
      '最多只能输入5个字': '最多只能输入5个字',
      '确定': '确 定',
      '编辑': '编辑',
      '确认删除该地址吗': '确认删除该地址吗？',
      '再想想': '再想想',
      '修改的信息还未保存': '修改的信息还未保存,',
      '确认现在返回么': '确认现在返回么？',
      '您还没有收货地址哦': '您还没有收货地址哦',
      '快去新建吧': '快去新建吧！~',
      '修改': '修改',
      '您要删除该收货地址吗': '您要删除该收货地址吗?',
      'newAddressError': '不允许出现X先生/X小姐等字样，请务必实名填写，详情阅读温馨提示',
      '收货人不能为空': '收货人不能为空',
      '所在地区不能为空': '所在地区不能为空',
      'mobileError': '手机号码格式不对，请重新输入',
      '手机号码不能为空': '手机号码不能为空',
      '详细地址不能为空': '详细地址不能为空',
      '请修改发货时间': '请修改发货时间',
      '请选择用户的配送地址': '请选择用户的配送地址',
      '运费最终运费以填写订单页为准': '运费与配送方式及配送地址相关，最终运费以填写订单页为准',
      '重量超过要运费': '重量超过Xkg，需支付续重费用，运费信息以订单确认页为准',
    },
  },
  card: {
    en: {
      '使用福利卡抵扣': 'Use bonus card for deduction',
      '绑定福利卡': 'Bind benefit card',
      'cardPWD': 'Please enter 16-digit card password, not case sensitive',
      'cardPWD1': 'Please enter 16-digit card password',
      'cardPWD2': 'not case sensitive',
      '立即绑定': 'Bind now',
      '扫码绑定': 'Scan to bind',
      '可用次数': 'Available times',
      '可用余额': 'Available Balances',
      '次': 'Times',
      '卡号': 'Card No.',
      '有效期至': 'Expiration date:',
      '确认绑定': 'Confirm bind',
      '确认绑定福利卡': 'Confirm binding benefit card',
      '请输入正确的卡密': 'Please enter correct card password',
      '绑定福利卡成功': 'Successful',
      '抵扣': 'Deduction',
      '请输入16位卡密码': 'Pls input card password of 16 digits',
      '确认绑定这张福利卡吗': 'Are you sure to bind this bonus card',
      '请输入四位数字支付密码': 'Pls input password of 4 digits!',
      '输入的密码4位数字不能相同或连续': '4-digit password cannot be same or continuous',
      '请再次输入四位数字支付密码': 'Pls input password of 4 digits again',
      'checkPayPwd': 'Password is inconsistent, please retype it',
      '暂无可用余额': 'No balances available',
      '暂无可用积分': 'No points available temporarily',
      '福豆': 'FuDou',
      '无可用卡': 'No available card',
      '已为您输入最大可用次数': 'You have entered the maximum number of available times',
      '请先获取验证码': 'Please get the verification code first',
      '验证码已发送至您的手机': 'The verification code has been sent to your mobile phone, please check it',
      '长期有效': 'Long-term effective',
    },
    cn: {
      '使用福利卡抵扣': '使用福利卡抵扣',
      '绑定福利卡': '绑定福利卡',
      'cardPWD': '请输入16位卡密，卡密不区分大小写',
      'cardPWD1': '请输入16位卡密',
      'cardPWD2': '卡密不区分大小写',
      '立即绑定': '立即绑定',
      '扫码绑定': '扫码绑定',
      '可用次数': '可用次数',
      '可用余额': '可用余额',
      '次': '次',
      '卡号': '卡号',
      '有效期至': '有效期至:',
      '确认绑定': '确认绑定',
      '确认绑定福利卡': '确认绑定福利卡',
      '请输入正确的卡密': '请输入正确的卡密',
      '绑定福利卡成功': '绑定福利卡成功',
      '抵扣': '抵扣',
      '请输入16位卡密码': '请输入16位卡密码',
      '确认绑定这张福利卡吗': '确认绑定这张福利卡吗',
      '请输入四位数字支付密码': '请输入四位数字支付密码!',
      'checkPayPwd': '两次输入不一致,请重新输入',
      '暂无可用余额': '暂无可用余额',
      '暂无可用积分': '暂无可用积分',
      '无可用卡': '无可用卡',
      '福豆': '福豆',
      '已为您输入最大可用次数': '已为您输入最大可用次数',
      '请先获取验证码': '请先获取验证码',
      '验证码已发送至您的手机': '验证码已发送至您的手机，请查收',
      '长期有效': '长期有效',
    },
  },
  user: {
    en: {
      '自动扣款': 'Auto deduction',
      '支付设置': 'Payment settings',
      '个人中心': 'Personal center',
      '我的福利': 'My welfare',
      '我的优惠券': 'My coupon',
      '电影订单': 'Movie order',
      '购物订单': 'Shopping order',
      '电子券订单': 'Electronic coupon order',
      '玩乐订单': 'Entertainment order',
      '旅游景点订单': 'Attraction order',
      '演出订单': 'Performance order',
      '健身订单': 'Fitness order',
      '体检订单': 'ME order',
      '我的问诊单': 'My consultation sheet',
      '兑换票师傅卡券': 'Exchange of piaoshifu card coupon',
      '个人信息': 'Personal information',
      '收货地址': 'Shipping Address',
      '账户绑定': 'Bind the account',
      '修改密码': 'Change password',
      '修改支付密码': 'Modify payment password',
      '您已关闭免密抵扣': 'You have turned off password-free deduction',
      '您已成功开启免密抵扣': 'Open password-free deduction',
      '去优选首页': 'Back homepage',
      '去商城首页': 'Back homepage',
      // eslint-disable-next-line
      '您还没有选择商品哦': "You haven't chosen the product yet~",
      '修改失败': 'Change failed',
    },
    cn: {
      '自动扣款': '自动扣款',
      '支付设置': '支付设置',
      '个人中心': '个人中心',
      '我的福利': '我的福利',
      '我的优惠券': '我的优惠券',
      '电影订单': '电影订单',
      '购物订单': '购物订单',
      '电子券订单': '电子券订单',
      '玩乐订单': '玩乐订单',
      '旅游景点订单': '旅游景点订单',
      '演出订单': '演出订单',
      '健身订单': '健身订单',
      '体检订单': '体检订单',
      '我的问诊单': '我的问诊单',
      '兑换票师傅卡券': '兑换票师傅卡券',
      '个人信息': '个人信息',
      '收货地址': '收货地址',
      '账户绑定': '账户绑定',
      '修改密码': '修改密码',
      '修改支付密码': '修改支付密码',
      '您已成功开启免密抵扣': '您已成功开启免密抵扣',
      '您已关闭免密抵扣': '您已关闭免密抵扣',
      '去优选首页': '去优选首页',
      '去商城首页': '去商城首页',
      '您还没有选择商品哦': '您还没有选择商品哦~',
      '修改失败': '修改失败',
    },
  },
  my: {
    en: {
      '查看更多门店': 'View more shops',
      '点击收起': 'Click to fold',
      '收起': 'Fold',
      '展开': 'Unfold',
      '任意金额': 'any',
      '元': 'RMB',
      '面值市场价': 'Nominal value/market price',
      '面值': 'Nominal value',
      '市场价': 'Market price',
      '销售价': 'Selling price',
      '名称': 'Name',
      '请选择配送城市': 'Pls select delivery city',
      '暂未选择': 'No selection',
      '选择配送城市': 'Select delivery city',
      '拼命加载中': 'Loading...',
      '加载中': 'Loading',
      '凑单页': 'Add-on items',
      '东福超市凑单页': 'DF market - Add-on items',
      '网易严选凑单页': 'Lifease - Add-on items',
      '小米有品凑单页': 'MI selection - Add-on items',
      '京东优选凑单页': 'JD preference - Add-on items',
      '图书凑单页': 'Books - Add-on items',
      '生日汇凑单页': 'Birthday - Add-on items',
      '第二个活动导航': 'Navigation',
      '先生': 'Mr.',
      '小姐': 'Ms.',
      '日': ' ',
      '月': '-',
      '年': '-',
      '特价': 'Special offer',
      '抢购': 'Flash offer',
      '全部频道': 'All channels',
      '沪ICP备16001915号': 'H.ICPB.No.16001915',
      '快捷按钮': 'Shortcut button',
      '频道首页': 'Channel homepage',
      '第二个后下单可选次日起发货': 'Goods can be sent next day if you place an order after (included)',
      '第二个下单可选今日发货': '(included)',
      '含含含': 'be sent today if you place an order before',
      '后下单可选次日起发货': 'Goods can be sent next day if you place an order after (included)',
      '下单可选次日起发货': '(included)',
      '含含': ' be sent next day if you place an order before',
      '当起发货': '(included)',
      '下单可选': 'if you place an order before',
      '含': 'be sent on',
      '前': 'Goods can',
      '起发货的': 'if you place an order after',
      '后下单可选': 'Goods can be sent on',
      '您确认要取消该订单吗': 'Are you sure you want to cancel this order?',
      '南京东路街道': '南京东路街道',
      '黄浦区': '黄浦区',
      '上海': 'Shanghai',
      '上海市': 'Shanghai',
      '热门': 'Popular',
      '已下架': 'Take-down',
      '立即购买': 'Buy now',
      '续重': 'Additional',
      '内': '内',
      '内包邮超重': '内包邮，超重',
      '包邮不满时需支付基础运费': '包邮，不满时需支付基础运费',
      '实付金额满': '实付金额满',
      '最低价': 'Min. price',
      '最高价': 'Max. price',
      '劳保用品': 'Labor protection supplies',
      '优选生活分类': 'Preferred life CAT',
      '当前已选城市': 'City selected：',
      '物流公司': 'Logistics company',
      '快递编号': 'Express code',
      '配送方式': 'Mode of Distribution',
      '内发货': '内发货',
      '至': 'to',
      '现在下单': '现在下单，商品将在',
      '再想想': 'Think twice',
      '删除后将无法找回订单': 'The order can\'t be retrieved once it is deleted. Are you sure to delete the order?',
      '删除订单': 'Delete order',
      '更多': 'More',
      '专享价': 'Exclusive price',
      '京东优选分类': 'JD preference CAT',
      '楼层导航': 'Navigation',
      'Floor': 'Navigation',
      '营业时间': 'Business hours',
      '电话': 'Cellphone',
      '地址': 'Address',
      '使用微信扫码立即体验随心兑': 'Use Wechat scan to enjoy go-as-you-please exchange',
      '微信扫一扫': 'Wechat scan',
      '随心兑': 'exchange',
      '可用，需到店使用': '可用，需到店使用',
      '消费任意可用': 'Available for any in-store consumption',
      '消费满可用': 'Available for XXXX in-store consumption',
      '消费': '消费',
      '折': 'off',
      '兑': '兑',
      '品牌故事': 'Brand story',
      '适用门店': 'Available shops',
      '商品': 'Product',
      '品牌详情': 'Brand details',
      '生日汇': 'Birthday',
      '购买': 'Buy',
      '在线支付': 'Online payment',
      '抵用券': 'Voucher',
      '券': 'Voucher',
      '品牌介绍': 'Brand introduction',
      '图书分类': 'Books CAT',
      '起': 'Start',
      '查看更多': 'View more',
      '热门推荐': 'Recommendation',
      '起发货': 'Delivery from',
      '起发货1': 'Delivery from ',
      '起发货2': ' ',
      '热门商品': 'Hot products',
      '生日汇正在热销中': 'Hot sale of birthday party',
      '电子抵用券': 'E-voucher',
      '蛋糕面包西饼': 'Cake, bread and pastry',
      '生日汇商品分类': 'Product category of birthday party',
      '生日汇精选品牌': 'Handpicked brands of birthday party',
      '所有产品分类': 'All product categories',
      '去购物车': 'Go cart',
      '超重': 'XX UU/kg for additional weight',
      '需支付运费': 'Freight to be paid',
      '内包邮': 'Free shipping for X kg',
      'kg内': 'within XXkg',
      '当前重量': 'Current weight：',
      '已达到包邮金额': 'Free delivery',
      '包邮': ' ',
      '还差': 'Free shipping for ',
      '取消': 'Cancel',
      '确定': 'Confirm',
      '价格': 'Price',
      '凑单商品': 'Add-on items',
      '东福超市': 'DF market',
      '网易严选': 'Lifease',
      '小米有品': 'MI selection',
      '京东优选': 'JD preference',
      '图书': 'Books',
      '优选生活': 'Preferred life',
      '去结算': 'Settle now',
      '查看商品详情': 'View details',
      '加入购物车成功': 'Add to Cart ',
      '回到顶部': 'Back to top',
      '活动导航': 'Navigation',
      '加入购物车': 'Add to cart',
      '数量': 'Quantity',
      '规格': 'Specification',
      '配件': 'Accessories',
      '售价': 'Selling price',
      '我知道了': 'I know',
      '购买数量从': '购买数量从',
      '由于商品的限购数量发生了变化': '由于商品的限购数量发生了变化，所以购买数量从',
      '改为了': '改为了',
      '由于商品的起购数量发生了变化': 'Purchase quantity has changed from X to X due to the change of min. quantity',
      '个商品发生了变化': ' products in cart change',
      '购物车内的': '',
      '企业定制': 'Enterprise customization',
      '健康商城': 'Health shopping mall',
      '口腔健康': 'Mouth health',
      '体检预约': 'Medical examination appointment',
      '首页': 'Home',
      '退出账号': 'Exit',
      '个人中心': 'Me',
      '删除': 'Delete',
      '全部删除': 'Delete all',
      '最近搜过': 'Latest search',
      '福豆': 'FuDou',
      '个商品': 'product(s)',
      '约': 'About',
      '可用福利卡抵扣的商品': 'Deductible products by bonus card',
      '搜索': 'Search',
      '微信版':'Wechat version',
      '服务热线':'hotline：',
      '卡劵使用指南':'Guide to the use of card coupons',
      '购物车':'Cart',
      '我的账户':'My account',
      '商城首页':'Mall',
      '注册':'Register',
      '登录':'Login',
      '退出登录':'Exit',
      '欢迎来到东方福利网':'Welcome！',
      '东福乐影卡': '东福乐影卡',
      '东福生日汇': '东福生日汇',
      '东福超级卡': '东福超级卡',
      '东福产品': '东福产品',
      '常见问题': '常见问题',
      '退货政策': '退货政策',
      '售后服务': '售后服务',
      '配送说明': '配送说明',
      '支付方式': 'Mode of payment',
      '购买指南': '购买指南',
      '卡券使用指南': '卡券使用指南',
      '购物指南': '购物指南',
      '沪公网安备':'H.G.W.A.B.No.31010502004928',
      '预付卡章程':'Prepaid card rule',
      '违法和不良信息举报电话':'Complaint call of illegal acts and malicious info.：021-61352872',
      '隐私政策':'隐私政策',
      '增值电信业务经营许可证':'Telecom value-added service business certificate: H.B2-20190068',
      '酒类商品零售许可证':'Alcohol product retail license: H.M.J.Z.Zi.No. 1306030113004373',
      '出版物经营许可证':'Publication business certificate: X.C.F.H.L.Zi.No. K7696',
      '第二类医疗器械经营备案凭证':'Second category medical device operation registration certificate: H.M.S.Y.J.X.J.Y.B.No. 20190028',
      '上海东福网络科技有限公司':'Shanghai Dongfu Network Technology Co., Ltd.',
      '微信扫一扫关注东福':'Wechat scanning to follow DF',
      '返回顶部':'Top',
      '周一至周日': 'From Mon. to Sun.',
      '周一至周五': 'From Mon. to Fri.',
      '贴心客服热线': 'Customer service hotline',
      '在线客服': 'Online customer service',
      '东方福利网': 'DF',
      '重量': 'Weight',
      '选择新地址': 'Pls select new address',
      '送至': 'Deliver to',
      '品牌': 'Brand',
      '全部': 'All',
      '分类': 'CAT',
      '已选': 'Selected',
      '自动扣款': 'Auto deduction',
      '支付设置': 'Payment settings',
      '周日': 'Sun.',
      '周一': 'Mon.',
      '周二': 'Tues.',
      '周三': 'Wed.',
      '周四': 'Thur.',
      '周五': 'Fri.',
      '周六': 'Sat.',
      '订单列表': 'Order List',
      '购物订单': 'Shopping order',
      '订单详情': 'Order Detail',
      '物流信息': 'Logistics info.',
      '起购数量从x变y1': 'Purchase quantity has changed from ',
      '起购数量从x变y2': ' to ',
      '起购数量从x变y3': ' due to the change of min. quantity.',
      '限购数量从x变y1': 'Purchase quantity has changed from ',
      '限购数量从x变y2': ' to ',
      '限购数量从x变y3': ' due to the change of limited purchase.',
      '购买数量从x变y1': 'Purchase quantity has changed from ',
      '购买数量从x变y2': ' to ',
    },
    cn: {
      '查看更多门店': '查看更多门店',
      '点击收起': '点击收起',
      '收起': '收起',
      '展开': '展开',
      '任意金额': '任意金额',
      '元': '元',
      '面值市场价': '面值/市场价',
      '面值': '面值',
      '市场价': '市场价',
      '销售价': '销售价',
      '名称': '名称',
      '请选择配送城市': '请选择配送城市',
      '暂未选择': '暂未选择',
      '选择配送城市': '选择配送城市',
      '拼命加载中': '拼命加载中',
      '加载中': '加载中...',
      '凑单页': '凑单页',
      '东福超市凑单页': '东福超市 - 凑单页',
      '网易严选凑单页': '网易严选 - 凑单页',
      '小米有品凑单页': '小米有品 - 凑单页',
      '京东优选凑单页': '京东优选 - 凑单页',
      '图书凑单页': '图书 - 凑单页',
      '生日汇凑单页': '生日汇 - 凑单页',
      '第二个活动导航': '活&nbsp动&nbsp导&nbsp航',
      '先生': '先生',
      '小姐': '小姐',
      '日': '日',
      '月': '月',
      '年': '年',
      '抢购': '抢购',
      '特价': '特价',
      '全部频道': '全部频道',
      '沪ICP备16001915号': '沪ICP备16001915号',
      '快捷按钮': '快捷按钮',
      '频道首页': '频道首页',
      '第二个后下单可选次日起发货': '后下单,可选次日起发货',
      '第二个下单可选今日发货': '下单,可选今日发货',
      '含含含': '含',
      '后下单可选次日起发货': '后下单,可选次日起发货',
      '下单可选次日起发货': '下单,可选次日起发货',
      '含含': '含',
      '当起发货': '起发货',
      '下单可选': '下单,可选',
      '含': '含',
      '前': '前',
      '起发货的': '起发货',
      '后下单可选': '后下单,可选',
      '您确认要取消该订单吗': '您确认要取消该订单吗?',
      '南京东路街道': '南京东路街道',
      '黄浦区': '黄浦区',
      '上海': '上海',
      '上海市': '上海市',
      '热门': '热门',
      '已下架': '已下架',
      '立即购买': '立即购买',
      '续重': '续重',
      '内': '内',
      '内包邮超重': '内包邮，超重',
      '包邮不满时需支付基础运费': '包邮，不满时需支付基础运费',
      '实付金额满': '实付金额满',
      '最低价': '最低价',
      '最高价': '最高价',
      '劳保用品': '劳保用品',
      '优选生活分类': '优选生活分类',
      '当前已选城市': '当前已选城市:',
      '物流公司': '物流公司:',
      '快递编号': '快递编号:',
      '配送方式': '配送方式:',
      '内发货': '内发货',
      '至': '至',
      '现在下单': '现在下单，商品将在',
      '再想想': '再想想',
      '删除后将无法找回订单': '删除后将无法找回订单，您确认删除吗？',
      '删除订单': '删除订单',
      '更多': '更多',
      '专享价': '专享价',
      '京东优选分类': '京东优选分类',
      '楼层导航': '楼层导航',
      'Floor': '楼&nbsp层&nbsp导&nbsp航',
      '营业时间': '营业时间',
      '电话': '电话',
      '地址': '地址',
      '使用微信扫码立即体验随心兑': '使用微信扫码 立即体验随心兑',
      '微信扫一扫': '微信扫一扫',
      '随心兑': '随心兑',
      '可用，需到店使用': '可用，需到店使用',
      '消费任意可用': '消费任意金额可用，需到店使用',
      '消费满可用': '消费满XXXX元可用，需到店使用',
      '消费': '消费',
      '折': '折',
      '兑': '兑',
      '品牌故事': '品牌故事',
      '适用门店': '适用门店',
      '商品': '商品',
      '品牌详情': '品牌详情',
      '生日汇': '生日汇',
      '购买': '购买',
      '在线支付': '在线支付',
      '抵用券': '抵用券',
      '券': '券',
      '品牌介绍': '品牌介绍:',
      '图书分类': '图书分类',
      '起': '起',
      '查看更多': '查看更多',
      '热门推荐': '热门推荐',
      '起发货': '起发货',
      '起发货1': ' ',
      '起发货2': '起发货',
      '热门商品': '热门商品',
      '生日汇正在热销中': '生日汇正在热销中',
      '电子抵用券': '电子抵用券',
      '蛋糕面包西饼': '蛋糕面包西饼',
      '生日汇商品分类': '生日汇商品分类',
      '生日汇精选品牌': '生日汇精选品牌',
      '所有产品分类': '所有产品分类',
      '去购物车': '去购物车',
      '超重': '超重 XX UU/kg',
      '需支付运费': '需支付运费',
      '内包邮': 'Xkg内包邮',
      'kg内': 'XXkg内',
      '当前重量': '当前重量：',
      '已达到包邮金额': '已达到包邮金额',
      '包邮': '包邮',
      '还差': '还差',
      '取消': '取消',
      '确定': '确定',
      '价格': '价格',
      '凑单商品': '凑单商品',
      '东福超市': '东福超市',
      '网易严选': '网易严选',
      '小米有品': '小米有品',
      '京东优选': '京东优选',
      '图书': '图书',
      '优选生活': '优选生活',
      '去结算': '去结算',
      '查看商品详情': '查看商品详情',
      '加入购物车成功': '加入购物车成功',
      '回到顶部': '回到顶部',
      '活动导航': '活动导航',
      '加入购物车': '加入购物车',
      '数量': '数量',
      '规格': '规格',
      '配件': '配件',
      '售价': '售价',
      '我知道了': '我知道了',
      '购买数量从': '购买数量从',
      '由于商品的限购数量发生了变化': '由于商品的限购数量发生了变化，所以购买数量从',
      '改为了': '改为了',
      '由于商品的起购数量发生了变化': '由于商品的起购数量发生了变化，所以购买数量从',
      '个商品发生了变化': '个商品发生了变化',
      '购物车内的': '购物车内的',
      '企业定制': '企业定制',
      '健康商城': '健康商城',
      '口腔健康': '口腔健康',
      '体检预约': '体检预约',
      '首页': '首页',
      '退出账号': '退出账号',
      '个人中心': '个人中心',
      '删除': '删除',
      '全部删除': '全部删除',
      '最近搜过': '最近搜过',
      '福豆': '福豆',
      '个商品': '个商品',
      '约': '约',
      '可用福利卡抵扣的商品': '可用 福利卡 抵扣的商品',
      '搜索': '搜索',
      '微信版': '微信版',
      '服务热线': '服务热线：',
      '卡劵使用指南': '卡劵使用指南',
      '购物车': '购物车',
      '我的账户': '我的账户',
      '商城首页': '商城首页',
      '注册': '注册',
      '登录': '登录',
      '退出登录': '退出登录',
      '欢迎来到东方福利网': '欢迎来到东方福利网！',
      '东福乐影卡': '东福乐影卡',
      '东福生日汇': '东福生日汇',
      '东福超级卡': '东福超级卡',
      '东福产品': '东福产品',
      '常见问题': '常见问题',
      '退货政策': '退货政策',
      '售后服务': '售后服务',
      '配送说明': '配送说明',
      '支付方式': '支付方式',
      '购买指南': '购买指南',
      '卡券使用指南': '卡券使用指南',
      '购物指南': '购物指南',
      '沪公网安备': '沪公网安备31010502004928号',
      '预付卡章程': '预付卡章程',
      '违法和不良信息举报电话': '违法和不良信息举报电话：021-61352872',
      '隐私政策': '隐私政策',
      '增值电信业务经营许可证': '增值电信业务经营许可证：沪B2-20190068',
      '酒类商品零售许可证': '酒类商品零售许可证：沪闵酒专字 第1306030113004373号',
      '出版物经营许可证': '出版物经营许可证：新出发沪零字第K7696号',
      '第二类医疗器械经营备案凭证': '第二类医疗器械经营备案凭证：沪闵食药监械经营备20190028号',
      '上海东福网络科技有限公司': '上海东福网络科技有限公司',
      '微信扫一扫关注东福': '微信扫一扫  关注东福',
      '返回顶部': '返回顶部',
      '周一至周日': '周一至周日',
      '周一至周五': '周一至周五',
      '贴心客服热线': '贴心客服热线',
      '在线客服': '在线客服',
      '东方福利网': '东方福利网',
      '重量': '重量',
      '选择新地址': '选择新地址',
      '送至': '送至',
      '品牌': '品牌',
      '全部': '全部',
      '分类': '分类:',
      '已选': '已选:',
      '自动扣款': '自动扣款',
      '支付设置': '支付设置',
      '周日': '周日',
      '周一': '周一',
      '周二': '周二',
      '周三': '周三',
      '周四': '周四',
      '周五': '周五',
      '周六': '周六',
      '订单列表': '订单列表',
      '购物订单': '购物订单',
      '订单详情': '订单详情',
      '物流信息': '物流信息',
      '起购数量从x变y1': '由于商品的起购数量发生了变化，所以购买数量从 ',
      '起购数量从x变y2': ' 改为了 ',
      '起购数量从x变y3': ' ',
      '限购数量从x变y1': '由于商品的限购数量发生了变化，所以购买数量从 ',
      '限购数量从x变y2': ' 改为了 ',
      '限购数量从x变y3': ' ',
      '购买数量从x变y1': '购买数量从 ',
      '购买数量从x变y2': ' 改为了 ',
    },
  },
  list: {
    en: {
      '超出部分的':'/kg for excess part',
      '请返回e家银充值': 'Back e-bank for charge',
      '抵扣失败弹框': '抵扣失败弹框',
      '卡密输入框': '卡密输入框',
      '积分盘点中请稍后再试': 'This order is not deducted. Credits are checked, pls try again later',
      '本次抵扣失败！': '本次抵扣失败！',
      '黄牛弹框': '黄牛弹框',
      '二次确认密码输入框': '二次确认密码输入框',
      '新的密码输入框': '新的密码输入框',
      '支付密码': '支付密码',
      '设置4位支付密码': 'Please Set 4-digit payment password',
      '输入手机号码输入框': '输入手机号码输入框',
      '绑定手机号': '绑定手机号',
      '未使用弹框': '未使用弹框',
      '未使用': '未使用',//这个单词分开来翻译：您有可用xxx未使用
      '您有可用': '您有可用',//这个单词分开来翻译：您有可用xxx未使用
      '优惠券引导': '优惠券引导',
      '优惠券信息': '优惠券信息',
      '可用次数': 'Available times',
      '运费Freight': 'Freight',
      '取消Cancel': 'Cancel',
      '保存Save': 'Save',
      '设置为默认收货地址SetasDefault': 'Set as default shipping address',
      '新增收货地址AddNewAddress': 'Add New Address',
      '修改Alter': 'Alter',
      '设为默认SetasDefault': 'Set as Default',
      '默认Default': 'Default',
      '新建收货地址NewAddress': 'Add new shipping address',
      '收货信息DeliveryInfo': 'Delivery Info:',
      '失效商品InvalidProduct': 'InvalidProduct',
      '含运费': 'Freight included: ',
      '配送方式DeliveryMethod:': 'Mode of Distribution',
      '确认商家信息和配送方式ConfirmBusinessInfoandDeliveryMethod': 'Confirm Business Info.and Delivery Method',
      '及之前送达具体送达时间以实际物流配送时间为准': 'Specific delivery time is subject to real-time logistics.',
      '预计': 'Delivery is estimated to be prior to',
      '期望发货时间ExpectedTimeofDelivery': 'Expected Time of Delivery',
      '期望送达时间ExpectedTimeofArrival': 'Expected Time of Arrival',
      '配送时间TimeofDelivery': 'Deliverytime Time of Delivery',
      '配件选择Accessory': 'Accessories selection Accessory',
      '生日快乐': 'Happy Birthday',
      '应付金额Amount Due': 'Amount payable Amount Due:',
      '立减Discount': 'Deducted Discount',
      '超出部分': 'kg,超出部分',
      '超出重量': 'kg excess weight',
      '总重量': 'Total weight',
      '第二个填写并核对收货信息': 'Fill out and check the receiving information Fill and Double Check Delivery Info.',
      '填写并核对收货信息': 'Fill out and check the receiving information',
      '将以非专享价进行结算': 'it will be settled at the non-exclusive price.',
      '此商品购买数量超过专享价可购数': 'If the purchase quantity of this product exceeds the allowable purchase quantity for exclusive price ',
      '此商品专享价可购剩余数为将以非专享价进行结算': 'The available product with exclusive offer is 0. Settlement is subject to regular price.',
      '保存': 'Save',
      '使用': '使用',
      '个人信息': 'Personal information',
      '重新设置': 'Pls reset',
      '请重新设置': 'Pls reset',
      '本次开通失败': '本次开通失败！',
      '将为您开通免密设置': '将为您开通免密设置',
      '是否退出免密设置': '是否退出免密设置？',
      '确认关闭': '确认关闭？',
      '关闭免密抵扣后会增加下单时间': '关闭免密抵扣后, 会增加下单时间',
      '去设置': '去设置',
      '去绑定': '去绑定',
      '请先绑定': 'Pls bind firstly',
      '您还未绑定手机号': 'You haven’t yet bound phone number',
      '时无需支付密码下单更便捷': '时，无需支付密码，下单更便捷',
      '抵扣金额': 'Deduction amount',
      '免密抵扣': 'password-free deduction',
      '基础信息': '基础信息',
      '快去新建吧': 'Create now!',
      '您还没有收货地址': 'You don’t have delivery address~',
      '联系方式': 'Contact way',
      '个': 'individual',
      '个收货地址最多可创建': '个收货地址，最多可创建',
      '您已创建': '您已创建',
      '是否删除该商品': 'Do you want to delete this product?',
      '删除即视为放弃该奖品': 'You are deemed to waive the prize if you choose deletion',
      '参加满减活动': 'Participate in the cash-back activity',
      '可享满': 'Cash back',
      '再买': 'Get',
      '减': 'back',
      '已享满': 'Cash back',
      '去凑单': 'Add-on items',
      '包邮还差': 'Free delivery Balance',
      '满': 'cash',
      '赶紧去逛逛': 'Go shopping！',
      '您的购物车还是空的哦': 'Your shopping cart is empty~',
      '礼包商品如下': 'Gift bas as follows',
      '如需与优选商品一起结算': '如需与优选商品一起结算，可以使用【超级卡】或第三方支付',
      '限购买礼包商品': 'Gift bag only',
      '东福礼品卡': 'DF gift card',
      '您的': 'Your',
      '不清空': 'Do not clear',
      '您要清空失效商品吗': 'Do you want to clear the expired products?',
      '不删除': 'Do not delete',
      '您要删除选中的商品吗': 'Do you want to delete the selected product?',
      '已选删除即视为放弃该奖品': 'The selected product includes prize. You are deemed to waive the prize if you delete it!',
      '确认删除选中的商品？': 'Are you sure to delete the selected products?',
      '合计不含运费': 'Total (excluding freight)',
      '已选商品': 'selected',
      '清空失效商品': 'Clear the expired products',
      '删除选中商品': 'Delete selected products',
      '全选': 'Select all',
      '我的购物车': 'My shopping cart',
      '切换城市': 'Change city',
      '仅看有货': 'Only view available',
      '清空': 'Clear',
      '热度': 'Popularity',
      '新品': 'New arrival',
      '销量': 'Sales volume',
      '综合': 'Overall',
      '返回上一步': 'Back',
      '抱歉没有找到相关的商品哦': 'Sorry ~ no relevant products found ~',
      '商品列表': 'Product list',
      '逛逛首页': 'Homepage',
      '上一页': 'Previous page',
      '抱歉商品过期不存在': 'Sorry, the product is expired and does not exist~',
      '起购': 'Minimum',
      '限购': 'Limited purchase',
      '最近浏览': 'Latest browsing history',
      '补货中': 'Replenishing',
      '抢光了': 'Sellout',
      '货源充足': 'Sufficient supply',
      '货源稀少': 'Scarce supply of goods',
      '该地区暂不支持配送': 'Delivery is not available for this region',
      '不支持配送': 'Delivery is not available',
      '常用地址': 'Usual address',
      '继续购物': 'Continue to buy',
      '商品详情': 'Product details',
      '说明一个礼': 'Note: one gift box contains two. Quantities limited: rain check',
      '赠品': 'Free gifts',
      '不计重量': 'Weight excluded',
      '商品以非专享价进行结算': '件), 若下单数量超过限购数时，商品以非专享价进行结算',
      '件享受优惠专享价剩余可购': '件享受优惠(专享价剩余可购',
      '购买不超过': '购买不超过',
      '专享限购': 'Exclusive sale',
      '满减': 'Cash back',
      '优惠': 'Discount',
      '商品编码': 'Product code',
      '限时特惠': 'Limited offer',
      '仅剩X件':'X left',
      '件': ' Pcs',
      '仅剩': 'left ',
      '东福抢购': 'Flash offer',
      '天': 'Day',
      '距离结束': 'Only left',
      '限时特价': 'Flash sale',
      '起开始发货': ' ',
      '现在下单': 'Order now, delivered from',
      '继续逛逛': 'Continue shopping',
      '赶紧去购物吧': 'go shopping now!',
      '还没有您的订单哦': 'You don’t have orders',
      '剩余': 'left',
      '仓库':'Warehouse',
      '仓库编码': 'Warehouse code',
      '订单号': 'Order number',
      '操作': 'Operation',
      '历史订单': 'Order history',
      '退款相关': 'Refund related',
      '待支付': 'To be paid',
      '已支付': 'Paid',
      '已完成': 'Done',
      '已取消': 'Cancelled',
      '全部订单': 'All orders',
      '客服电话请忽略按的提示音内容': 'Customer service telephone number: 400 618 299 9-1 (please ignore the prompt tone when pressing 1, just press 1 for consultation) Monday to Sunday 9:00-21:00',
      '联系客服': '联系客服',
      '申请退款': 'refund',
      '查看物流': 'View logistics',
      '以上为最新跟踪信息': 'The above is the latest follow-up information',
      '查看全部': 'view all',
      '包裹': 'Parcel ',
      '个包裹发出': ' parcels and sent out',
      '该订单拆成': 'The order was split into ',
      '取消订单': 'Cancel order',
      '下单时间': 'Order time',
      '订单编号': 'Order No：',
      '邮编': 'Zip code：',
      '退款方式': 'Refund mode',
      '退款明细': 'Refund details',
      '状态': 'statuses',
      '支付时间': 'Payment time',
      '支付金额/次额': 'Payment amount/number',
      '东方福利卡号': 'DONGFANGFULI.COM card no.',
      '支付明细': 'Payment details',
      '继续支付': 'Pay now',
      '订单详情': 'Order details',
      '以上商品本卡暂不支持购买': 'This card is unavailable for above products',
      '起邮管局通知': 'The Postal Administration informs that since September 01, 2018, the name of the recipient as well as the name of the sender on the logistics information of all express deliveries must be filled in with the real name, and it is prohibited to fill in with surnames and other characters. Please fill in the recipient information in your real name, otherwise no delivery will be made. Thank you for your cooperation!',
      '失效': 'Invalid',
      '件商品小计': 'products，subtotal',
      '共件商品': '共件商品',
      '进入提交订单页,选择相应的优惠券并使用': 'Access to order submition page to choose available coupons',
      '扫描下方二维码': 'Scan QR code below',
      '通过以下方式': 'Open "scan" via the following methods',
      '返回修改': 'Return for modification',
      '生日牌内容': 'Birthday plate content',
      '提交订单': 'Submit Order',
      '运费收取规则': 'Freight collection rule',
      '续重运费': 'Additional weight',
      '基础运费': 'Basic freight',
      '件商品商品总价': 'products Total price of products',
      '商品总价': 'Total price of products',
      '件商品': 'products',
      '共': 'Pcs',
      '点我扫码': 'scan the QR code to get your special offer',
      '张优惠券可以在本笔订单使用': '张优惠券可以在本笔订单使用',
      '有': 'Expiry',
      '张优惠券': '张优惠券',
      '您共有': '您共有',
      '自动扣款': 'Auto deduction',
      '支付设置': 'Payment settings',
      '还剩活动结束': 'XXXX left before the activity is finished',
      '还剩恢复原价': 'XXXX left before restoration of the original price',
      'presaleOrder': 'Product will be delivered within sss to eee if you place an order now',
      '最低价不能大于最高价': 'Min. price more than max. price!',
      '带有此标记就是特惠价': 'The price with this mark is current special offer',
      '当前售卖价': 'Current selling price',
      '日常售卖价': 'Daily selling price',
      '已享满减': 'XX rebated for YY amount',
      '再买享满': 'Buy ZZ to obtain JJ cash back for MM amount',
      '满x包邮差y包邮': 'Free freight if you have XX UU. Free freight if you have YY more UU.',
      '奖品': 'Prize',
      '抽奖': '抽奖',
    },
    cn: {
      '仅剩X件':'仅剩X件',
      '超出部分的':'超出部分',
      '请返回e家银充值': '请返回 e 家银充值',
      '抵扣失败弹框': '抵扣失败弹框',
      '卡密输入框': '卡密输入框',
      '积分盘点中请稍后再试': '积分盘点中，请稍后再试',
      '本次抵扣失败！': '本次抵扣失败！',
      '黄牛弹框': '黄牛弹框',
      '二次确认密码输入框': '二次确认密码输入框',
      '新的密码输入框': '新的密码输入框',
      '支付密码': '支付密码',
      '设置4位支付密码': '设置4位支付密码',
      '输入手机号码输入框': '输入手机号码输入框',
      '绑定手机号': '绑定手机号',
      '未使用弹框': '未使用弹框',
      '未使用': '未使用',//这个单词分开来翻译：您有可用xxx未使用
      '您有可用': '您有可用',//这个单词分开来翻译：您有可用xxx未使用
      '优惠券引导': '优惠券引导',
      '优惠券信息': '优惠券信息',
      '可用次数': '可用次数',
      '运费Freight': '运费Freight',
      '取消Cancel': '取消Cancel',
      '保存Save': '保存Save',
      '设置为默认收货地址SetasDefault': '设置为默认收货地址 Set as Default',
      '新增收货地址AddNewAddress': '新增收货地址Add New Address',
      '修改Alter': '修改Alter',
      '设为默认SetasDefault': '设为默认 Set as Default',
      '默认Default': '默认 Default',
      '新建收货地址NewAddress': '新建收货地址New Address',
      '收货信息DeliveryInfo': '收货信息Delivery Info',
      '失效商品InvalidProduct': '失效商品Invalid Product',
      '含运费': '含运费：',
      '配送方式DeliveryMethod:': '配送方式Delivery Method:',
      '确认商家信息和配送方式ConfirmBusinessInfoandDeliveryMethod': '确认商家信息和配送方式Confirm Business Info.and Delivery Method',
      '及之前送达具体送达时间以实际物流配送时间为准': '及之前送达具体送达时间以实际物流配送时间为准',
      '预计': '预计',
      '期望发货时间ExpectedTimeofDelivery': '期望发货时间Expected Time of Delivery',
      '期望送达时间ExpectedTimeofArrival': '期望送达时间Expected Time of Arrival',
      '配送时间TimeofDelivery': '配送时间Time of Delivery:',
      '配件选择Accessory': '配件选择Accessory Accessory',
      '生日快乐': '生日快乐',
      '应付金额Amount Due': '应付金额Amount Due:',
      '立减Discount': '立减Discount',
      '超出部分': 'kg,超出部分',
      '超出重量': 'kg,超出重量',
      '总重量': '总重量',
      '第二个填写并核对收货信息': '填写并核对收货信息Fill and Double Check Delivery Info.',
      '填写并核对收货信息': '填写并核对收货信息',
      '将以非专享价进行结算': '将以非专享价进行结算',
      '此商品购买数量超过专享价可购数': '此商品购买数量超过专享价可购数',
      '此商品专享价可购剩余数为将以非专享价进行结算': '此商品专享价可购剩余数为 0，将以非专享价进行结算',
      '保存': '保存',
      '使用': '使用',
      '个人信息': '个人信息',
      '重新设置': '重新设置',
      '请重新设置': '请重新设置',
      '本次开通失败': '本次开通失败！',
      '将为您开通免密设置': '将为您开通免密设置',
      '是否退出免密设置': '是否退出免密设置？',
      '确认关闭': '确认关闭？',
      '关闭免密抵扣后会增加下单时间': '关闭免密抵扣后, 会增加下单时间',
      '去设置': '去设置',
      '去绑定': '去绑定',
      '请先绑定': '请先绑定',
      '您还未绑定手机号': '您还未绑定手机号',
      '时无需支付密码下单更便捷': '时，无需支付密码，下单更便捷',
      '抵扣金额': '抵扣金额',
      '免密抵扣': '免密抵扣：',
      '基础信息': '基础信息',
      '快去新建吧': '快去新建吧！',
      '您还没有收货地址': '您还没有收货地址~',
      '联系方式': '联系方式',
      '个': '个',
      '个收货地址最多可创建': '个收货地址，最多可创建',
      '您已创建': '您已创建',
      '是否删除该商品': '是否删除该商品?',
      '删除即视为放弃该奖品': '删除即视为放弃该奖品',
      '参加满减活动': '参加满减活动',
      '可享满': '可享满',
      '再买': '再买',
      '减': '减',
      '已享满': '已享满',
      '去凑单': '去凑单',
      '包邮还差': '包邮，还差',
      '满': '满',
      '赶紧去逛逛': '赶紧去逛逛！',
      '您的购物车还是空的哦': '您的购物车还是空的哦~',
      '礼包商品如下': '礼包商品如下:',
      '如需与优选商品一起结算': '如需与优选商品一起结算，可以使用【超级卡】或第三方支付',
      '限购买礼包商品': '限购买礼包商品',
      '东福礼品卡': '东福礼品卡',
      '您的': '您的',
      '不清空': '不清空',
      '您要清空失效商品吗': '您要清空失效商品吗?',
      '不删除': '不删除',
      '您要删除选中的商品吗': '您要删除选中的商品吗?',
      '已选删除即视为放弃该奖品': '已选商品中包含奖品，删除即视为放弃该奖品！',
      '确认删除选中的商品': '确认删除选中的商品？',
      '合计不含运费': '合计（不含运费）：',
      '已选商品': '已选商品',
      '清空失效商品': '清空失效商品',
      '删除选中商品': '删除选中商品',
      '全选': '全选',
      '我的购物车': '我的购物车',
      '切换城市': '切换城市',
      '仅看有货': '仅看有货',
      '清空': '清空',
      '热度': '热度',
      '新品': '新品',
      '销量': '销量',
      '综合': '综合',
      '返回上一步': '返回上一步',
      '抱歉没有找到相关的商品哦': '抱歉~没有找到相关的商品哦~',
      '商品列表': '商品列表',
      '逛逛首页': '逛逛首页',
      '上一页': '上一页',
      '抱歉商品过期不存在': '抱歉，商品过期不存在~',
      '起购': '起购',
      '限购': '限购',
      '最近浏览': '最近浏览',
      '补货中': '补货中',
      '抢光了': '抢光了',
      '货源充足': '货源充足',
      '货源稀少': '货源稀少',
      '该地区暂不支持配送': '该地区暂不支持配送',
      '不支持配送': '不支持配送',
      '常用地址': '常用地址',
      '继续购物': '继续购物',
      '商品详情': '商品详情',
      '说明一个礼': '说明：一个礼盒赠两张，数量有限，赠完即止',
      '赠品': '赠品',
      '不计重量': '不计重量',
      '商品以非专享价进行结算': '件), 若下单数量超过限购数时，商品以非专享价进行结算',
      '件享受优惠专享价剩余可购': '件享受优惠(专享价剩余可购',
      '购买不超过': '购买不超过',
      '专享限购': '专享限购',
      '满减': '满减',
      '优惠': '优惠',
      '商品编码': '商品编码',
      '限时特惠': '限时特惠',
      '件': '件',
      '仅剩': '仅剩',
      '东福抢购': '东福抢购',
      '天': '天',
      '距离结束': '距离结束',
      '限时特价': '限时特价',
      '起开始发货': '起开始发货',
      '现在下单': '现在下单，',
      '继续逛逛': '继续逛逛',
      '赶紧去购物吧': '赶紧去购物吧！',
      '还没有您的订单哦': '还没有您的订单哦~',
      '剩余': '剩余',
      '仓库':'仓库',
      '仓库编码': '仓库编码',
      '订单号': '订单号',
      '操作': '操作',
      '历史订单': '历史订单',
      '退款相关': '退款相关',
      '待支付': '待支付',
      '已支付': '已支付',
      '已完成': '已完成',
      '已取消': '已取消',
      '全部订单': '全部订单',
      '客服电话请忽略按的提示音内容': '客服电话: 400 618 2999-1（请忽略按1的提示音内容，直接按1咨询即可） 周一至周日9:00-21:00',
      '联系客服': '联系客服',
      '申请退款': '申请退款',
      '查看物流': '查看物流',
      '以上为最新跟踪信息': '以上为最新跟踪信息',
      '查看全部': '查看全部',
      '包裹': '包裹',
      '个包裹发出': '个包裹发出',
      '该订单拆成': '该订单拆成',
      '取消订单': '取消订单',
      '下单时间': '下单时间',
      '订单编号': '订单编号：',
      '邮编': '邮编：',
      '退款方式': '退款方式',
      '退款明细': '退款明细',
      '状态': '状态',
      '支付时间': '支付时间',
      '支付金额/次额': '支付金额/次额',
      '东方福利卡号': '东方福利卡号',
      '支付明细': '支付明细',
      '继续支付': '继续支付',
      '订单详情': '订单详情',
      '以上商品本卡暂不支持购买': '以上商品本卡暂不支持购买',
      '起邮管局通知': '2018.09.01起，邮管局通知：所有快递物流信息上收件人以及寄件人信息禁止出现X先生/X小姐等字样，务必实名填写。请您实名填写收件信息，否则不予发货，谢谢配合！',
      '失效': '失效',
      '件商品小计': '件商品，小计:',
      '共件商品': '共件商品',
      '进入提交订单页,选择相应的优惠券并使用': '进入提交订单页,选择相应的优惠券并使用',
      '扫描下方二维码': '扫描下方二维码',
      '通过以下方式': '通过以下方式，打开“扫一扫”',
      '返回修改': '返回修改',
      '生日牌内容': '生日牌内容:',
      '提交订单': '提交订单',
      '运费收取规则': '运费收取规则',
      '续重运费': '续重运费',
      '基础运费': '基础运费',
      '件商品商品总价': '件商品，商品总价',
      '商品总价': '商品总价',
      '件商品': '件商品',
      '共': '共',
      '点我扫码': '点我扫码，立享优惠',
      '张优惠券可以在本笔订单使用': '张优惠券可以在本笔订单使用',
      '有': 'Expiry',
      '张优惠券': '张优惠券',
      '您共有': '您共有',
      '自动扣款': '自动扣款',
      '支付设置': '支付设置',
      '还剩活动结束': '还剩XXXX活动结束',
      '还剩恢复原价': '还剩XXXX恢复原价',
      'presaleOrder': '现在下单，商品将在 sss 至 eee 内发货',
      '最低价不能大于最高价': '最低价不能大于最高价!',
      '带有此标记就是特惠价': '带有此标记的商品价格,就是您当前专享的特惠价',
      '当前售卖价': '当前售卖价',
      '日常售卖价': '日常售卖价',
      '已享满减': '已享满YY减XX',
      '再买享满': '再买ZZ可享满MM减JJ',
      '满x包邮差y包邮': '满XXUU包邮，还差YYUU包邮',
      '奖品': '奖品',
      '抽奖': '抽奖',
    },
  },
  goods: {
    en: {
      '剩余X分X秒': 'X min XX sec left',
      '共x件': 'XXX Pcs',
      '该商品仅剩': 'Sorry, SSS piece(s) left',
      '商品仅剩':'SSS piece(s) left',
      '该商品起购': 'mini. QQQ',
      '该商品限购': 'XXX limited',
      '限购x件': 'XXX limited',
      '起购x件': 'mini.XXX',
      'y件起购': 'mini.XXX',
      '仅剩z件': 'XXX left',
      '数量不能为空': 'Quantity shall not be vacant!',
      '修改失败': 'Change failed',
      '网络错误': 'Network error, please try again later!',
      '领取成功去使用': 'Claim successfully and go now~',
      '满XXX可用': 'Available for purchase over XXX',
      '满减': 'Cash back',
      '特价': 'Special offer',
      '抢购': 'Flash offer',
      '新品': 'New arrival',
      '购物车内数量变化': 'XXX products in cart change',
      '购物车内的': ' ',
      '数量变化': ' products in cart change',
      '由于商品的起购数量发生了变化，所以购买数量从': 'Quantity changes from ',
      '起购改为了1': ' to ',
      '起购改为了2': ' as min. purchase quantity changes',
      '由于商品的限购数量发生了变化，所以购买数量从': 'Quantity changes from ',
      '限购改为了1': ' to ',
      '限购改为了2': ' as min. purchase quantity changes',
      '购买数量从': 'Quantity changes from ',
      '数量改为了1': ' to ',
      '该地区暂不支持配送': 'Delivery is not available for this region',
      '地址解析失败': 'Fail to parse address!',
      '初始化成功': 'Successful initialization!',
      '解析地址发生异常': 'Address resolution is abnormal!',
      '获取定位失败': 'Fail to obtain location!',
      '后下单起发货': 'Goods can be sent on QQQQ if you place an order after HHHH',
      '前下单起发货': 'Goods can be sent on QQQQ if you place an order before HHHH (included)',
      '前下单次日发货': 'Goods can be sent next day if you place an order before HHHH (included)',
      '后下单次日发货': 'Goods can be sent next day if you place an order after HHHH (included)',
      '前下单今日发货': 'Goods can be sent today if you place an order before HHHH (included)',
      '倒计时天': 'day',
      '倒计时年': '-',
      '倒计时月': '-',
      '倒计时日': ' ',
      '请重新登录': 'Pls login again',
      '起发货': 'Delivery from XXXX',
      '缺少必要参数id': 'Required parameter id is missing',
      '优惠劵凑单列表': 'Coupon add-items list',
      '没有找到相关哦': 'no relevant found',
      '最低金额不能大于最高金额': 'min. amount must be less than max. amount',
      '请输入数量和数字': 'Please enter a quantity and a number, for example: 2, 20 (representing two pieces, the number consists of 2 and 0)',
      '请输入卡片祝福内容': 'Please enter your wishes in the card',
      '请输入巧克力牌内容': 'Please enter the content of chocolate sign that contains up to 8 Chinese characters or 16 English characters. For example: Happy Birthday',
      '点击收起': 'Click to fold',
      '点击加载更多': 'Click to load more',
      '上拉，至下一个分类': 'Pull up to next category',
      // eslint-disable-next-line
      '您没有可以使用的优惠券哦': "You don't have a coupon to use~",
      // eslint-disable-next-line
      '你还没有使用过优惠券哦': "You haven't used coupons yet~",
      // eslint-disable-next-line
      '您没有过期的优惠券哦': "You don't have expired coupons~",
      '满X可用': 'Available for purchase over X',
      '东方福利网': 'DF',
      '返回我的': 'Return to my',
      '抱歉，商品过期不存在': 'Sorry, the product is expired and does not exist',
      '上一页': 'Previous page',
      '物流信息': 'Logistics info.',
      '配送时间': 'Delivery time',
      '送达时间': 'Delivery time',
      '无可查询的活动ID': 'There is no activity ID to query, please return to the previous page to get it again',
      // eslint-disable-next-line
      '来晚了，活动结束了': "It's late, and the activity is over.",
      '当前城市/收货地址无法参与该满减活动': 'This cash-back activity is not available for the current city/shipping address, please change the city/shipping address',
      '还差X包邮': 'Free shipping for XXXX UUUU',
      '包邮1': 'Free shipping for ',
      '包邮2': ' ',
      '最高价': 'Max. price',
      '最低价': 'Min. price',
      '该商品已售罄': 'Sold out',
      '实付金额满包邮不满运费': 'The freight will be exempted if amount paid is more than MMM UUU. Otherwise, you need to pay YYY UUU for basic freight',
      '实付金额满包邮不满运费续重': 'The freight will be exempted if amount paid is more than MMM UUU and weight less than and equal to QQQ kg. Otherwise, you need to pay YYY UUU for basic freight and CCC UUU/kg for additional weight.',
      '免运费超重': 'Freight free (free shipping for MMM kg and CCC UUU/kg for additional weight)',
      '商品详情页': 'Product Detail',
      '预售': 'Presale',
    },
    cn: {
      '剩余X分X秒': '剩余X分X秒',
      '共x件': '共XXX件',
      '该商品仅剩': '抱歉，该商品仅剩SSS件了',
      '商品仅剩':'该商品仅剩SSS件了',
      '该商品起购': '该商品QQQ起购',
      '该商品限购': '该商品限购XXX件',
      '限购x件': '限购XXX件',
      '起购x件': '起购XXX件',
      'y件起购': 'XXX件起购',
      '仅剩z件': '仅剩XXX件',
      '数量不能为空': '数量不能为空！',
      '修改失败': '修改失败',
      '网络错误': '网络错误，请稍后重试！',
      '领取成功去使用': '领取成功,快去使用吧~',
      '满XXX可用': '满XXX可用',
      '满减': '满减',
      '特价': '特价',
      '抢购': '抢购',
      '新品': '新品',
      '购物车内数量变化': '购物车内的 XXX 个商品发生了变化',
      '购物车内的': '购物车内的 ',
      '数量变化': ' 个商品发生了变化',
      '由于商品的起购数量发生了变化，所以购买数量从': '由于商品的起购数量发生了变化，所以购买数量从',
      '起购改为了1': '改为了',
      '起购改为了2': ' ',
      '由于商品的限购数量发生了变化，所以购买数量从': '由于商品的限购数量发生了变化，所以购买数量从',
      '限购改为了1': '改为了',
      '限购改为了2': ' ',
      '购买数量从': '购买数量从',
      '数量改为了1': '改为了',
      '该地区暂不支持配送': '该地区暂不支持配送',
      '地址解析失败': '地址解析失败!',
      '初始化成功': '初始化成功!',
      '解析地址发生异常': '解析地址发生异常!',
      '获取定位失败': '获取定位失败!',
      '后下单起发货': 'HHHH后下单,可选QQQQ起发货',
      '前下单起发货': 'HHHH前(含HHHH)下单,可选QQQQ起发货',
      '前下单次日发货': 'HHHH前(含HHHH)下单,,可选次日起发货',
      '后下单次日发货': 'HHHH后下单,可选次日起发货',
      '前下单今日发货': 'HHHH前(含HHHH)下单,,可选今日发货',
      '倒计时天': '天',
      '倒计时年': '年',
      '倒计时月': '月',
      '倒计时日': '日',
      '请重新登录': '请重新登录',
      '起发货': 'XXXX起发货',
      '缺少必要参数id': '缺少必要参数id',
      '优惠劵凑单列表': '优惠劵凑单列表',
      '没有找到相关哦': '没有找到相关哦',
      '最低金额不能大于最高金额': '最低金额不能大于最高金额',
      '请输入数量和数字': '请输入数量和数字，例如:2个,20(代表数量两个,数字一个2,一个0)',
      '请输入卡片祝福内容': '请输入卡片祝福内容',
      '请输入巧克力牌内容': '请输入巧克力牌内容，最多8个汉字或16个英文。例如：生日快乐',
      '点击收起': '点击收起',
      '点击加载更多': '点击加载更多',
      '上拉，至下一个分类': '上拉，至下一个分类',
      '您没有可以使用的优惠券哦': '您没有可以使用的优惠券哦～',
      '你还没有使用过优惠券哦': '你还没有使用过优惠券哦～',
      '您没有过期的优惠券哦': '您没有过期的优惠券哦～',
      '满X可用': '满X可用',
      '东方福利网': '东方福利网',
      '返回我的': '返回我的',
      '抱歉，商品过期不存在': '抱歉，商品过期不存在',
      '上一页': '上一页',
      '物流信息': '物流信息',
      '配送时间': '配送时间',
      '送达时间': '送达时间',
      '无可查询的活动ID': '无可查询的活动ID，请返回上一页重新获取',
      '来晚了，活动结束了': '来晚了，活动结束了。',
      '当前城市/收货地址无法参与该满减活动': '当前城市/收货地址无法参与该满减活动，请更改城市/收货地址',
      '还差X包邮': '还差XXXXUUUU包邮',
      '包邮1': '还差',
      '包邮2': '包邮',
      '最高价': '最高价',
      '最低价': '最低价',
      '该商品已售罄': '该商品已售罄',
      '实付金额满包邮不满运费': '实付金额满MMMUUU包邮，不满时需支付基础运费YYYUUU',
      '实付金额满包邮不满运费续重': '实付金额满MMMUUU且重量≤QQQkg包邮，不满时需支付基础运费YYYUUU，续重CCCUUU/kg',
      '免运费超重': '免运费(MMMkg内包邮，超重CCCUUU/kg)',
      '商品详情页': '商品详情页',
      '预售': '预售',
    },
  },
  order: {
    en: {
      '剩余支付时间': 'Payment time left',
      '支付完成等待商家配货': 'Finish payment and wait delivery',
      '支付失败，请重新下单': 'Fail to pay, pls place an order again',
      '付款超时订单已取消': 'Time-out order has been cancelled',
      '商品已收货，交易完成': 'Product has been accepted. Transaction ends',
      '退款中，请稍候': 'Refunding, pls wait',
      '待支付': 'To be paid',
      '已支付': 'Paid',
      '待配货': 'To be distributed',
      '已发货': 'Delivered',
      '已签收': 'Accepted',
      '已取消': 'Cancelled',
      '配送中': 'Delivering',
      '拒收': 'Reject',
      '退款中': 'Refunding',
    },
    cn: {
      '剩余支付时间': '剩余支付时间',
      '支付完成等待商家配货': '支付完成等待商家配货',
      '支付失败，请重新下单': '支付失败，请重新下单',
      '付款超时订单已取消': '付款超时订单已取消',
      '商品已收货，交易完成': '商品已收货，交易完成',
      '退款中，请稍候': '退款中，请稍候',
      '待支付': '待支付',
      '已支付': '已支付',
      '待配货': '待配货',
      '已发货': '已发货',
      '已签收': '已签收',
      '已取消': '已取消',
      '配送中': '配送中',
      '拒收': '拒收',
      '退款中': '退款中',
    },
  },
  common: {
    cn: {
      '电影票、话剧票、健身': '电影票、话剧票、健身...',
      '请添加或选择用户收货地址': '请添加或选择用户收货地址',
      '其他': '其他',
      '分类': '分类',
      '语言': '简体中文',
      '消息': '消息',
      '企业首页': '企业首页',
    },
    en: {
      '电影票、话剧票、健身': 'Movie tickets, drama tickets, fitness...',
      '请添加或选择用户收货地址': 'Please add or select the shipping address of the user',
      '其他': 'Others',
      '分类': ' CAT',
      '语言': 'English',
      '消息': 'Message',
      '企业首页': 'Home',
    },
  },
  paypending: {
    cn: {
      '订单提交成功': '订单提交成功',
      '审核中': '审核中',
      '审核剩余时间': '审核剩余时间',
      '审核剩余': '审核剩余',
      '提交订单': '提交订单',
      '订单审核': '订单审核',
      '订单支付': '订单支付',
      '审核通过后': '审核通过后，请尽快查看订单完成支付',
      '返回首页': '返回首页',
      '查看订单': '查看订单',
      '请在订单审核通过后完成支付': '请在订单审核通过后完成支付',
      '驳回原因': '驳回原因',
      '知道了': '知道了',
      '原因': '原因',
      '支付剩余时间': '支付剩余时间',
      '支付剩余': '支付剩余',
    },
    en: {
      '订单提交成功': 'Order submitted successfully',
      '审核中': 'Review in progress',
      '审核剩余时间': 'Remaining review time',
      '审核剩余': 'Remaining review time',
      '提交订单': 'Submit order',
      '订单审核': 'Order Review',
      '订单支付': 'Order Payment',
      '审核通过后': 'After the review, please check the order as soon as possible to complete the payment',
      '返回首页': 'Back homepage',
      '查看订单': 'View order',
      '请在订单审核通过后完成支付': 'Pls complete payment after order approval',
      '驳回原因': '驳回原因',
      '知道了': 'Read',
      '原因': 'Reason for rejection',
      '支付剩余时间': 'Pay remaining time',
      '支付剩余': 'Pay remaining time',
    },
  },
  brand: {
    cn: {
      '需平台服务费': '需平台服务费',
      '去购买': '去购买',
      "全部区域":"全部区域",
      "暂无数据": "暂无数据",
      "电话": "电话",
      "去兑换":  "去兑换",
      "配送到家": "配送到家",
      "电子券": "电子券",
      "随心兑": "随心兑",
      "品牌故事": "品牌故事",
      "请输入名称查找门店": "请输入名称查找门店",
      "获取路线": '获取路线',
      "暂时无法定位该门店": "暂时无法定位该门店",
      "加载中": "加载中",
      "加载失败": "加载失败，请重新加载",
      "当前城市暂未开通该品牌": "当前城市暂未开通该品牌",
    },
    en: {
      '需平台服务费': 'Platform service fee is required',
      '去购买': 'buy',
      "全部区域":"All regions",
      "暂无数据": "No data",
      "去兑换":"Exchange",
      "电话": "Tel",
      "配送到家": "Home delivery",
      "电子券": "E-coupon",
      "随心兑": "Easy exchange",
      "品牌故事": "Brand Story",
      "请输入名称查找门店": "Enter a name to search for stores",
      "获取路线": 'get directions',
      "暂时无法定位该门店": "Unable to locate the store temporarily",
      "加载中": "Loading",
      "加载失败": "Loading failed, please reload",
      "当前城市暂未开通该品牌":'The brand is currently not available in the current city',
    },
  },
};
